import { FunctionComponent, useContext, useEffect, useRef, useState } from "react";
import { ActionsContext, LocalGameActions } from "./ActionsContext";
import { useAppSelector } from "./store/hooks";
import { getDB } from "./Firebase";
import { doc, onSnapshot, setDoc, serverTimestamp } from "firebase/firestore";

const EMOJIS = ["👍", "😂", "😱", "🎯", "💪", "👋", "🎲", "🔥"];
const SHOW_MS = 3000;

type FloatingEmoji = { id: number; emoji: string; fromOpponent: boolean };

type Props = { lobbyDocId?: string };

const EmojiReactions: FunctionComponent<Props> = ({ lobbyDocId }) => {
  const actions     = useContext(ActionsContext);
  const profile     = useAppSelector(s => s.user.profile);
  const [open, setOpen]       = useState(false);
  const [floating, setFloating] = useState<FloatingEmoji[]>([]);
  const idRef = useRef(0);

  useEffect(() => {
    if (!lobbyDocId) return;
    const ref = doc(getDB(), "lobbies", lobbyDocId);
    const unsub = onSnapshot(ref, snap => {
      const data = snap.data();
      const reaction = data?.lastReaction;
      if (!reaction?.emoji || !reaction?.ts) return;
      const age = Date.now() - (reaction.ts.toMillis?.() ?? 0);
      if (age > 5000) return; // старые реакции игнорируем
      const fromOpponent = reaction.uid !== profile?.uid;
      if (!fromOpponent) return; // свои уже показали локально
      showEmoji(reaction.emoji, true);
    });
    return () => unsub();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lobbyDocId, profile?.uid]);

  const showEmoji = (emoji: string, fromOpponent: boolean) => {
    const id = ++idRef.current;
    setFloating(prev => [...prev, { id, emoji, fromOpponent }]);
    setTimeout(() => setFloating(prev => prev.filter(e => e.id !== id)), SHOW_MS);
  };

  const send = async (emoji: string) => {
    setOpen(false);
    showEmoji(emoji, false);
    if (!lobbyDocId || !profile) return;
    try {
      await setDoc(doc(getDB(), "lobbies", lobbyDocId), {
        lastReaction: { uid: profile.uid, emoji, ts: serverTimestamp() },
      }, { merge: true });
    } catch {}
  };

  if (actions instanceof LocalGameActions || !lobbyDocId) return null;

  return (
    <div className="Emoji-wrap">
      {/* Плавающие реакции */}
      {floating.map(f => (
        <div key={f.id} className={`Emoji-float ${f.fromOpponent ? "opponent" : "mine"}`}>
          {f.emoji}
        </div>
      ))}

      {/* Кнопка открытия */}
      <button
        type="button"
        className="Game-bottom-icon-btn"
        onClick={() => setOpen((v) => !v)}
        title="Реакция"
        aria-label="Реакция эмодзи"
        style={{ fontSize: "1.2rem", lineHeight: 1 }}
      >
        😊
      </button>

      {/* Панель выбора */}
      {open && (
        <div className="Emoji-picker">
          {EMOJIS.map(e => (
            <button key={e} className="Emoji-btn" onClick={() => send(e)}>{e}</button>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmojiReactions;
